import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { buildUrl } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { RequiredPayloadFieldIsNotProvided } from '@savgroup-front-common/exceptions/client/errors/RequiredPayloadFieldIsNotProvided';
import { BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.catalog}models/${COMMON_QUERY_PARAMS.MODEL_ID}/repairable`;

export interface GetRepairableByModelIdPayload {
  id: string;
  sellerId?: string;
}

interface GetRepairableByModelIdResponse extends BaseBackResponse {
  value: boolean;
}

export const getRepairableByModelIdRequest = (
  payload: GetRepairableByModelIdPayload,
): ApiRequestDescriptor => ({
  url: buildUrl(
    ENDPOINT.replace(COMMON_QUERY_PARAMS.MODEL_ID, payload.id),
    { sellerId: payload.sellerId },
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

async function getRepairableByModelId({
  id,
  sellerId,
}: GetRepairableByModelIdPayload): Promise<boolean> {
  const functionName = 'getRepairableByModelId';

  if (!id) {
    throw new RequiredPayloadFieldIsNotProvided(id, `${functionName}`);
  }

  const response = await executeQuery<GetRepairableByModelIdResponse>(
    getRepairableByModelIdRequest({ id, sellerId }),
  );

  return response.value;
}

export default getRepairableByModelId;
